import { onUnmounted, unref, watch } from 'vue';
import { useStore } from 'dashboard/composables/store';
import { INBOX_TYPES } from 'dashboard/helper/inbox';

export const useGupshupTemplatesSync = (
  inboxIdRef,
  getInbox,
  { debounceMs = 400 } = {}
) => {
  const store = useStore();
  let gupshupTemplatesSyncTimer = null;

  watch(
    () => unref(inboxIdRef),
    inboxId => {
      if (gupshupTemplatesSyncTimer) {
        clearTimeout(gupshupTemplatesSyncTimer);
        gupshupTemplatesSyncTimer = null;
      }

      gupshupTemplatesSyncTimer = setTimeout(async () => {
        gupshupTemplatesSyncTimer = null;
        if (!inboxId) return;

        const inbox = getInbox?.(inboxId);
        const channelType = inbox?.channelType || inbox?.channel_type;
        if (!inbox || channelType !== INBOX_TYPES.GUPSHUP) {
          return;
        }

        try {
          await store.dispatch('inboxes/syncTemplates', inboxId);
        } catch (error) {
          console.warn('[Gupshup] template sync failed', error);
        }
      }, debounceMs);
    }
  );

  onUnmounted(() => {
    if (gupshupTemplatesSyncTimer) {
      clearTimeout(gupshupTemplatesSyncTimer);
    }
  });
};
